import loadHeroImage from "shared/lib/load_hero_image"
import truncate from "lodash/truncate"

import "./related_content.scss"

interface RelatedContentProps {
  relatedContent: {
    type: "story" | "consumer_solution"
    slug: string
    title: string
    hero_image: {
      background_image_url_1x: string | null
      background_color: string | null
      solution_image: string | null
    }
    description: string | null
    url: string
  }[]
}

const RelatedContent = ({ relatedContent }: RelatedContentProps) => (
  <>
    <h2>You may also like</h2>
    <section styleName="related-content">
      {(relatedContent || []).map(content => {
        return (
          <a key={content.slug} href={content.url} rel="noreferrer" styleName="story-card">
            <div
              styleName="hero"
              title={content.title}
              aria-label={content.title}
              style={
                content.hero_image.background_color && {
                  backgroundColor: `${content.hero_image.background_color}`,
                }
              }
            >
              <img
                src={loadHeroImage(content.hero_image, "square")}
                title={content.title}
                alt={content.title}
                loading="lazy"
                width="336"
                height="200"
              />
            </div>
            <div styleName="title">
              <h5>{content.title}</h5>
            </div>

            <p styleName="description">
              {truncate(content.description, {
                length: 240,
                separator: /[ ,]/,
              })}
            </p>
          </a>
        )
      })}
    </section>
  </>
)

export default RelatedContent
